//--------------------
// get action to-slot
//--------------------
export default function getActionToSlot(ca, actual_action_count, action_count) {
  // console.log("****************************");
  // console.log("getActionToSlot....");
  //--------------
  // calc to-slot
  //--------------
  // console.log("ca = " + ca);
  // console.log("actual_action_count = " + actual_action_count);
  let remaining = ca - actual_action_count;
  // console.log("remaining = " + remaining);

  // console.log("action_count = " + action_count);
  let to_slot = action_count + remaining;
  // console.log("to_slot = " + to_slot);
  // console.log("****************************");

  return to_slot;
}
